import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ReturnRequestDto } from "../generated/schema";

interface UseApproveOrRejectReturnParams {
	onSuccess: (returnRequest: ReturnRequestDto) => void;
}

export default function useApproveOrRejectReturn(
	params: UseApproveOrRejectReturnParams,
) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();

	const mutation = $api.useMutation(
		"post",
		"/shops/{shopId}/return-requests/{returnRequestId}/approve-or-reject",
		{
			onSuccess(returnRequest) {
				successNotification();
				params.onSuccess(returnRequest);
			},
			onError() {
				errorNotification();
			},
		},
	);

	return useMutation({
		mutationFn: ({
			shopId,
			returnRequestId,
			status,
		}: {
			shopId: string;
			returnRequestId: string;
			status: string;
		}) => {
			return mutation.mutateAsync({
				params: {
					path: { shopId, returnRequestId },
				},
				body: { status },
			});
		},
	});
}
